import React from "react";
import DataTable from "../../DataTable";

const OtherUser = ({ other }) => {
  if (other && Array.isArray(other) && other.length > 0) {
    return (
      <div style={{ marginBottom: "20px" }}>
        <div style={{ borderBottom: "1px solid red" }} className="mb-2">
          <h4 style={{ fontSize: "18px" }}>مشخصات همراهان</h4>
        </div>
        <div className="row justify-content-between ">
          <div className="col-12 p-0 m-0">
            <DataTable
              heads={[
                {
                  title: "نام و نام خانوادگی",
                  key: "fullname",
                },
                {
                  title: "کد ملی",
                  key: "national_code",
                },
                {
                  title: "شماره همراه",
                  key: "mobile",
                },
              ]}
              short={true}
              textEmpty="همراهی وجود ندارد"
              list={other}
              data={other}
            />
          </div>
        </div>
      </div>
    );
  }
  return <></>;
};

export default OtherUser;
